import ApiConstants from "../../Constants/ApiConstant";
import { apiGet, apiPost } from "../../Services/ApiService";

export const getGlobalGenericNameAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.getGlobalGenericNameUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const createGenericDataAPI = (data, callBack) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createGenericDataUrl, data)
        .then((response) => {
          callBack && callBack(response?.data, response?.data);
        })
        .catch((err) => {
          throw err;
        });
    } catch (err) {
      throw err;
    }
  };
};

export const getLiveRateAPI = (data, callBack) => {
  return async () => {
    try {
      await apiGet(ApiConstants.liveRateDataURL, data)
        .then((response) => {
          callBack && callBack(response, response);
        })
        .catch((err) => {
          console.log("get live rate API err: ", err);
          throw err;
        });
    } catch (err) {
      console.log("get live rate API err: ", err);
      throw err;
    }
  };
};
